export default "__VITE_ASSET__CCDVJLNC__"